import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="organization-switcher"
export default class extends Controller {
  static targets = ["selector"]

  connect() {
    console.log('Organization switcher controller connected')
  }

  switch() {
    const selectedSlug = this.selectorTarget.value
    console.log('Organization switcher triggered:', selectedSlug)
    if (selectedSlug) {
      // Navigate to the selected organization's dashboard
      const url = `/organizations/${selectedSlug}`
      console.log('Navigating to:', url)
      window.location.href = url
    }
  }
}
